import { create } from 'zustand'

/**
 * State of each phone of this tab, read by the "Reconnecting the phone…" banner.
 * - eteint: not started, or turned off (logout, another tab took the phone)
 * - connexion: first connection
 * - pret: can place and receive calls
 * - reconnexion: lost, coming back on its own
 * - coupe: several attempts failed; the agent can ask for a reconnection
 */
export type EtatTelephone = 'eteint' | 'connexion' | 'pret' | 'reconnexion' | 'coupe'
export type FournisseurTelephone = 'twilio' | 'telnyx'

interface EtatTelephoneState {
  twilio: EtatTelephone
  telnyx: EtatTelephone
  changer: (fournisseur: FournisseurTelephone, etat: EtatTelephone) => void
}

export const useEtatTelephoneStore = create<EtatTelephoneState>((set) => ({
  twilio: 'eteint',
  telnyx: 'eteint',
  changer: (fournisseur, etat) => set((s) => (s[fournisseur] === etat ? s : { [fournisseur]: etat })),
}))

export function changerEtatTelephone(fournisseur: FournisseurTelephone, etat: EtatTelephone) {
  useEtatTelephoneStore.getState().changer(fournisseur, etat)
}
